module.exports = __webpack_public_path__ + "img/sort-down-alt.b7b42bde.svg";